export const environment = {
  production: false,
  apiUrl: 'https://api-engage.zgameslatam.com',
  landingBaseUrl: 'https://registro.zgameslatam.com',
};
